import {Injectable} from '@angular/core';

/**
 * Translations for club-overview.
 */
@Injectable()
export class ClubTranslationsService {
  public i18nSuccessClubUpdate: any = $localize`:@@alertService.alert.success.clubUpdated:Club was updated successfully!`;
  public i18nSuccessLogoClubUpload: any = $localize`:@@alertService.alert.success.clubLogoAdded:Logo was added successfully!`;

  public i18nErrorClubUpdate: any = $localize`:@@alertService.alert.error.clubUpdated:An error occured when updating the club!`;
  public i18nErrorClubNotExisting: any = $localize`:@@alertService.error.clubNotExisting:Error occurred. Club does not exist.`;
  public i18nErrorCannotUploadLogo: any = $localize`:@@alertService.alert.error.cannotUploadClubLogo:Error occurred. Could not upload logo.`;
  public i18nErrorCannotFetchLogo: any = $localize`:@@alertService.alert.error.cannotFetchClubLogo:Error occurred. Could not fetch club logo.`;
  public i18nErrorAttributeUpdate: any = $localize`:@@alertService.alert.error.attributeUpdated:An error occured when updating the attribute!`;
  public i18nErrorAttributeCreate: any = $localize`:@@alertService.alert.error.attributeCreate:An error occured when creating the attribute!`;

  public i18nWarningClubNoAccess: any = $localize`:@@alertService.warning.clubNoAccess:You do not have access to this club`;
  public i18nWarningCautiousSettings: any = $localize`:@@alertService.warning.cautiousSettings:Please be cautious when editing settings on this page as it might harm the application!`;

  constructor() { }
}
